import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { Badge } from 'reactstrap';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import { NotificationManager } from 'react-notifications';
import {
   contractAllStudent,
   contractFetchStudent,
   contractDeleteStudent
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import UpdateStudents from './component/viewform';

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';



class students extends Component {

   constructor(props) {

      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         viewdiv: true,
         adddiv: false,
         vdiv: false,
         editdiv: false,
         lsttype: [],
         selshot: '',
         seltype: '',
         seldrill: '',
         eid: '',
         fetchid:'',

      };


      this.onBackSection = this.onBackSection.bind(this);
      this.deleteForm = this.deleteForm.bind(this);
      this.onAddSession1 = this.onAddSession1.bind(this);
   }

   componentDidMount() {
      this.props.contractAllStudent();
   }


   onAddSession() {
      this.setState({
         viewdiv: false,
         editdiv: false,
         adddiv: true,
         vdiv: false,
      });
   }

   onBackSection() {
      this.setState({
         adddiv: false,
         viewdiv: true,
         editdiv: false,
         vdiv: false,

      });
   }


   onAddSession1(ctsID) {
      this.props.contractFetchStudent(ctsID).then((data) => {
         const details = data.data;
         const student=details.student;
         if(student.length!=0){
            this.setState({
               fetchid:ctsID,
               viewdiv: false,
               adddiv: false,
               vdiv: true
            })
         }else{
            NotificationManager.error("Student enrollment details not filled");
         }
      });
   }

   deleteForm(data) {
      this.data = data;
      this.confirmationDialog.current.openDialog();
   }

   deleteDataPermanent(popupResponse) {
      if (popupResponse) {
         this.props.contractDeleteStudent(this.data.ctsID);
         this.data = "";
      }
   }

   render() {
      const { match, contractstudentlist, loading } = this.props;
      const options = {
         filterType: 'dropdown',
         rowsPerPage: 50,
         responsive:'standard',
         rowsPerPageOptions: [50, 100, 150],
         selectableRowsHideCheckboxes: true,
      };

      const columns = [
         { name: "no", label: "NO" },
         { name: "studentname", label: "Student Name" },
         { name: "Parentname", label: "Parent Name" },
         { name: "Parentemail", label: "Parent Ema" },
         { name: "action", label: "View" },
         { name: "action1", label: "Delete" },
      ];

      const tabledata = contractstudentlist.map((assmntval, idx) => {
         const ebtn = (
            <MatButton className="btn-info mr-5 mb-5 btn-sm text-white" onClick={() => this.onAddSession1(assmntval.ctsID)}>
               View
            </MatButton>
         );
         const dbtn = (
            <IconButton className="text-danger" aria-label="Remove" onClick={() => this.deleteForm(assmntval)}>
               <DeleteOutlineOutlinedIcon/>
            </IconButton>
         );

         if (assmntval.cts_studentid != 0) {
            var studname = assmntval.uud_firstName + " " + assmntval.uud_lastName;
         } else {
            var studname = assmntval.cts_studentname + " " + assmntval.cts_studentlname;
         }


         return {
            no: idx + 1,
            studentname: studname,
            Parentname: assmntval.cts_parentname,
            Parentemail: assmntval.cts_parentemail,
            action: ebtn,
            action1: dbtn,
         };
      });
      return (
         <div className="saas-dashboard">
            <Helmet>
               <title> Student List | {AppConfig.appTitle}</title>
               <meta name="description" content="Golf" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.contractstudent" />} match={match} />

            {this.state.viewdiv &&
               <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                  <RctCollapsibleCard heading="List" fullBlock>
                     <MUIDataTable
                        title={<div><Button onClick={() => this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Student</Button></div>}
                        data={tabledata}
                        columns={columns}
                        options={options}
                     />
                  </RctCollapsibleCard>
               </div>
            }
            {this.state.adddiv &&
               <AddItem onClick={this.onBackSection} />
            }

            {this.state.editdiv &&
               <UpdateItems onClick={this.onBackSection} data={this.state} />
            }

            {this.state.vdiv &&
               <UpdateStudents onClick={this.onBackSection} data={this.state} />
            }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'student'}
            />

         </div>
      )
   }
}

const mapStateToProps = ({ contractstudent }) => {
   const { contractstudentlist, loading } = contractstudent;
   return { contractstudentlist, loading };
}

export default connect(mapStateToProps, {
   contractAllStudent,
   contractFetchStudent,
   contractDeleteStudent
})(students); 